import React, {FC} from 'react';

import styles from './styles.module.scss';

interface EncryptionButtonProps {
  encrypt: boolean;
  handleEncrypt: () => void;
}

const InputEncryptionButton: FC<EncryptionButtonProps> = ({
  encrypt,
  handleEncrypt,
}) => {
  return (
    <button
      type="button"
      className={styles.encryptButton}
      onClick={handleEncrypt}>
      <span>{encrypt ? 'SHOW' : 'HIDE'}</span>
    </button>
  );
};

export default InputEncryptionButton;
